import { ReactNode } from "react";

/**
 * HeaderItemNro
 */


type Props = {
  label: ReactNode | string;
  value: ReactNode | string | number | null;
  emptyValue?: string;
};

export const HeaderItemNro = ({
  label,
  value,
  emptyValue,
}: Props) => {
  return (
    <div className="flex flex-col">
      <span className="text-[10px] text-gray-500 dark:text-gray-400 uppercase font-bold tracking-wider">
        {label}
      </span>
      <span className="text-sm font-bold text-primary-green mt-0.5">
        {value !== null ? value : (emptyValue ?? '-')}
      </span>
    </div>
  );
}